type SectionTitleProps = {
  icon: React.ElementType;
  title: string;
  subtitle?: string;
};

export default function SectionTitle({ icon: Icon, title }: SectionTitleProps) {
  return (
    <div className="tw-flex tw-items-center tw-gap-2 tw-mb-1">
      <div className="tw-p-2 tw-rounded-full tw-bg-neutral-100 tw-text-neutral-600">
        <Icon className="tw-h-4 tw-w-4" />
      </div>
      <h4 className="tw-text-[16px]">{title}</h4>
    </div>
  );
}
